import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';

import type { AvaliacaoGlobal } from '../../types/operacoes';

const BASE_URL = '/admin/avaliacoes';

export interface AvaliacoesGlobaisParams {
  page?: number;
  limit?: number;
  search?: string;
  escritorioId?: string;
  periodo?: string;
  avaliacao?: string;
  sortBy?: string;
  sortOrder?: string;
}

export interface AvaliacoesGlobaisListResponse {
  data: AvaliacaoGlobal[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const avaliacoesGlobaisService = {
  async list(params: AvaliacoesGlobaisParams = {}): Promise<AvaliacoesGlobaisListResponse> {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    if (params.search) query.set('search', params.search);
    if (params.escritorioId) query.set('escritorioId', params.escritorioId);
    if (params.periodo) query.set('periodo', params.periodo);
    if (params.avaliacao) query.set('avaliacao', params.avaliacao);
    if (params.sortBy) query.set('sortBy', params.sortBy);
    if (params.sortOrder) query.set('sortOrder', params.sortOrder);

    const qs = query.toString();
    const url = qs ? `${BASE_URL}?${qs}` : BASE_URL;
    const response = await apiGet(url);
    return parseApiResponse<AvaliacoesGlobaisListResponse>(response);
  },
};
